import React from "react";
import Button from "@material-ui/core/Button";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import {
	FaShoppingBag,
	FaInstagram,
	FaTelegram,
	FaPaw,
	FaTwitter,
} from "react-icons/fa";
import FindInPage from "@material-ui/icons/FindInPage";
import { formatInstagram, formatTwitter, formatTelegram } from "./links";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Divider from "@material-ui/core/Divider";
import Fade from "@material-ui/core/Fade";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Tag from "./Tag";
import { connect } from "react-redux";
import tags from "../tags.json";
import Container from "@material-ui/core/Container";
import makeImgProps from "./makeImgProps";
import { withRouter } from "react-router";

const useStyles = makeStyles((theme) =>
	createStyles({
		button: {
			margin: theme.spacing(1),
		},
		bannerContainer: {
			width: "100%",
			height: "400px",
			overflow: "hidden",
			alignContent: "center",
			backgroundPosition: "center",
			backgroundSize: "cover",
		},
		banner: {
			height: "auto",
		},
		tagList: {
			display: "flex",
			flexWrap: "wrap",
			justifyContent: "center",
			marginBottom: theme.spacing(4),
		},
		tagItem: {
			margin: theme.spacing(0.5),
		},
		noMediaSpacer: {
			marginTop: theme.spacing(10),
		},
		backButtonContainer: {
			textAlign: "left",
		},
		backButton: {
			marginBottom: theme.spacing(1),
		},
		avatar: {
			width: theme.spacing(20),
			height: theme.spacing(20),
			marginLeft: "auto",
			marginRight: "auto",
			marginTop: -theme.spacing(10),
			marginBottom: theme.spacing(1),
			border: "2px solid white",
		},
	})
);

export default withRouter(
	connect((state, props) => ({
		dealer: state.dealers.find(({ id }) => id === props.match.params.id),
	}))((props) => {
		const classes = useStyles();
		const { dealer, history } = props;
		if (!dealer) {
			return null;
		}
		const {
			description,
			title,
			iconFile,
			coverFile,
			headline,
			twitter,
			instagram,
			telegram,
			shopUrl,
			fa,
			other,
			site,
		} = dealer;
		const matchingTags = tags.filter((tag) => dealer[tag]);
		const ExtLink = ({ startIcon, link, children }) =>
			link && (
				<Button
					variant="contained"
					color="secondary"
					className={classes.button}
					component="a"
					target="_blank"
					rel="noopener noreferrer"
					size="large"
					href={link}
					startIcon={startIcon}
				>
					{children}
				</Button>
			);
		return (
			<Fade in>
				<Container maxWidth="md">
					<div className={classes.backButtonContainer}>
						<Button
							variant="text"
							className={classes.backButton}
							startIcon={<ArrowBack />}
							onClick={() => history.goBack()}
						>
							Back
						</Button>
					</div>
					<Card className={classes.root}>
						{coverFile ? (
							<CardMedia
								component="img"
								{...makeImgProps(coverFile)}
								style={{ maxHeight: "70vh" }}
							/>
						) : (
							<div className={classes.noMediaSpacer} />
						)}
						<CardContent>
							<Typography
								gutterBottom
								variant="h2"
								component="h2"
							>
								<Avatar
									src={
										iconFile &&
										process.env.PUBLIC_URL +
											"/" +
											iconFile["320"]
									}
									style={
										iconFile
											? { backgroundColor: "white" }
											: {}
									}
									className={classes.avatar}
								/>
								{title}
							</Typography>
							<Container maxWidth="sm">
								<Typography variant="h5" paragraph>
									{headline}
								</Typography>
							</Container>
							<div className={classes.tagList}>
								{matchingTags.map((tagName) => (
									<Tag
										tag={tagName}
										key={tagName}
										className={classes.tagItem}
									/>
								))}
							</div>
							<Typography
								variant="body1"
								align="left"
								paragraph
								style={{
									whiteSpace: "pre-line",
								}}
							>
								{description}
							</Typography>
							<br />
							<Divider />
							<br />
							<div>
								<ExtLink
									link={shopUrl}
									startIcon={<FaShoppingBag />}
								>
									Shop
								</ExtLink>
								<ExtLink
									link={formatTwitter(twitter)}
									startIcon={<FaTwitter />}
								>
									Twitter
								</ExtLink>
								<ExtLink
									link={formatInstagram(instagram)}
									startIcon={<FaInstagram />}
								>
									Instagram
								</ExtLink>
								<ExtLink
									link={formatTelegram(telegram)}
									startIcon={<FaTelegram />}
								>
									Telegram
								</ExtLink>
								<ExtLink link={fa} startIcon={<FaPaw />}>
									FurAffinity
								</ExtLink>
								<ExtLink link={site} startIcon={<FindInPage />}>
									Website
								</ExtLink>
								<ExtLink link={other}>Other</ExtLink>
							</div>
						</CardContent>
					</Card>
				</Container>
			</Fade>
		);
	})
);
